<template>
<div class="chapter">
<div class="inner_page">
<div id="cover-image"><img alt="cover-image, new_master_mega" src="images/kindleArtboard_2_4x-100.jpg" title="new_master_mega"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?321156bd